import { useFetchApartments } from "../useFetchApartments.js";
import { RecommendedApartments } from "../Sections/Apartments/RecommendedApartments.tsx";
import Loading from "../Pages/Loading.jsx"
import "../Styling/Home.css";

export default function Home({ t, language }) {
  const { apartments, apartmentImages, loading } = useFetchApartments();

  return (
    <div className="pt-[50px]">
      {loading ? (
        <Loading />
      ) : (
        <RecommendedApartments
          language={language}
          t={t}
          apartments={apartments}
          apartmentImages={apartmentImages}
          reccomend={true}
        />
      )}</div>
  );
}
